import { useCallback, useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";

// Reads the user's credit balance from user_credits (RLS: own row). Canonical
// source for the Settings balance + the "via credits" meter indicator.
export interface CreditsState {
  balanceUnits: number;
  isLoading: boolean;
  refresh: () => void;
}

export function useCredits(): CreditsState {
  const [balanceUnits, setBalanceUnits] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [refreshKey, setRefreshKey] = useState(0);
  const refresh = useCallback(() => setRefreshKey((k) => k + 1), []);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) {
        if (!cancelled) { setBalanceUnits(0); setIsLoading(false); }
        return;
      }
      const { data, error } = await supabase
        .from("user_credits")
        .select("balance_units")
        .eq("user_id", user.id)
        .maybeSingle();
      if (cancelled) return;
      if (error) console.warn("[useCredits] query error", error);
      setBalanceUnits(typeof (data as { balance_units?: number } | null)?.balance_units === "number"
        ? (data as { balance_units: number }).balance_units
        : 0);
      setIsLoading(false);
    })();
    return () => { cancelled = true; };
  }, [refreshKey]);

  return { balanceUnits, isLoading, refresh };
}
